/**
 * Beocca Recently Viewed - localStorage based
 */
(function() {
  'use strict';

  const STORAGE_PREFIX = 'beocca_recently_viewed';
  const MAX_ITEMS = 10;

  /*
    Opslag per taal en valuta (1 sep 2026).

    Hier stond één sleutel voor de hele winkel. In localStorage ligt een
    momentopname van de titel, de URL, de foto en de prijs zoals die golden op
    het moment van bekijken - dus in de taal en valuta van dát bezoek. Wie een
    product in het Deens bekeek en daarna op /en/ verder klikte, kreeg onder
    "Recently viewed" nog de Deense titel te zien.

    Terughalen bij het renderen kan niet: de handles zijn per taal vertaald
    (rugzak-mavis / backpack-mavis / rucksack-mavis) en /en/products/rugzak-mavis.js
    geeft een 404. Er is dus geen sleutel die over talen heen werkt. Daarom staat
    de geschiedenis nu per taal-en-valuta apart. Wisselen van taal begint met een
    lege lijst en vult zich weer bij het volgende product - dat is de prijs voor
    een lijst die altijd in de goede taal staat.

    De links blijven overigens wel werken over talen heen: Shopify stuurt
    /da/products/backpack-mavis met een 301 door naar de Deense handle.
  */
  function storageKey() {
    const root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      (window.theme && window.theme.routes && window.theme.routes.rootUrlSlash) ||
      '/';
    const currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    return STORAGE_PREFIX + ':' + root + ':' + currency;
  }

  // Oude lijst zonder taal weggooien: van die items weten we niet in welke taal
  // ze zijn opgeslagen, dus ze zijn niet naar een van de nieuwe sleutels te tillen.
  try { localStorage.removeItem(STORAGE_PREFIX); } catch { /* private mode */ }

  const ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, c => ESCAPES[c]);
  }

  const RecentlyViewed = {
    getAll() {
      try {
        const items = JSON.parse(localStorage.getItem(storageKey()));
        if (!Array.isArray(items)) return [];
        return items.filter(item => item && typeof item.handle === 'string' &&
          typeof item.url === 'string' && /^\/(?!\/)/.test(item.url));
      } catch { return []; }
    },

    save(items) {
      try {
        localStorage.setItem(storageKey(), JSON.stringify(items));
      } catch { /* private mode of vol */ }
    },

    track(product) {
      if (!product || !product.handle) return;
      let items = this.getAll();
      // Remove if already exists
      items = items.filter(i => i.handle !== product.handle);
      // Add to front
      items.unshift({
        handle: product.handle,
        title: product.title,
        url: product.url,
        image: product.image,
        price: product.price,
        trackedAt: Date.now()
      });
      // Limit
      if (items.length > MAX_ITEMS) items = items.slice(0, MAX_ITEMS);
      this.save(items);
    },

    render(containerId, excludeHandle) {
      const container = document.getElementById(containerId);
      if (!container) return;

      const items = this.getAll().filter(i => i.handle !== excludeHandle);
      if (items.length === 0) {
        container.closest('.recently-viewed-section')?.setAttribute('hidden', '');
        return;
      }

      container.closest('.recently-viewed-section')?.removeAttribute('hidden');
      // Titels bevatten een duimteken (15,6"), dus alles wat in een attribuut
      // belandt moet ge-escaped worden - anders knipt de alt-tekst zichzelf af.
      container.innerHTML = items.slice(0, 4).map(item => `
        <div class="recently-viewed__item">
          <a href="${esc(item.url)}" class="recently-viewed__link">
            ${item.image ? `<div class="recently-viewed__img-wrap"><img src="${esc(item.image)}" alt="${esc(item.title)}" width="200" height="200" loading="lazy" class="recently-viewed__img"></div>` : ''}
            <span class="recently-viewed__title">${esc(item.title)}</span>
            ${item.price ? `<span class="recently-viewed__price">${esc(item.price)}</span>` : ''}
          </a>
        </div>
      `).join('');
    }
  };

  window.BeoccaRecentlyViewed = RecentlyViewed;
})();
